/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useRef, useEffect } from 'react';
import ApexChart from 'react-apexcharts';

export type TChartType =
  | 'area'
  | 'line'
  | 'bar'
  | 'histogram'
  | 'pie'
  | 'donut'
  | 'radialBar'
  | 'scatter'
  | 'bubble'
  | 'heatmap'
  | 'treemap';

export interface IApexChartWidgetProps {
  type: TChartType;
  height?: number;
  chartSeries?: any;
  chartOptions?: any;
}

export const ApexChartWidget = ({
  type,
  height,
  chartSeries,
  chartOptions,
}: IApexChartWidgetProps) => {
  const chartRef = useRef<any>(null);
  // @ts-ignore
  return (
    <ApexChart
      type={type}
      height={height}
      series={chartSeries}
      options={chartOptions}
      ref={chartRef}
    />
  );
};

ApexChartWidget.defaultProps = {
  height: 420,
};
